<template>
    <div>
        <topfind class="top_tab" :path="path" :page="find.page"></topfind>
        <dia :dialog="dialog"></dia>

        <litable :listdata="wordList" :col-configs="tablist" :page="page" :pagesize="pageInputOver">
            <el-table-column slot="opt" label="操作" width="300px">
                <template slot-scope="scope">
                    <div class="buttom_c">
                        <el-button size="mini" @click="handleClick(scope.row,'查看')">查看</el-button>
                        <el-button size="mini" @click="handleClick(scope.row,'编辑')">编辑</el-button>
                        <el-button size="mini" @click="handleClick(scope.row,'删除')">删除</el-button>
                    </div>
                </template>
            </el-table-column>
        </litable>

        <el-footer>
            <div class="block">
                <p>每页条数</p>
                <el-input v-model="pageInput" @change="pageSizeChange" class="page_input" size="mini"></el-input>
                <el-pagination v-if="path==='/启动页查看'||path==='/作文查看'||path==='/优秀作文查看'?false:true"
                    @current-change="getather" :current-page.sync="currentPage" :page-size="pageInputOver"
                    layout="prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </el-footer>
    </div>
</template>
<script>
    import litable from '@/components/li-table'
    import topfind from '@/components/Topmenu'
    import dia from '@/components/li-dialog'
    import testServer from '@/api/management.js'
    import {
        mapState,
        mapMutations,
        mapActions
    } from 'vuex'
    export default {
        components: {
            litable,
            topfind,
            dia
        },
        data() {
            return {
                path: '',
                pageInputOver: 20,
                pageInput: 20,
                currentPage: '1',
                dialog: {
                    dialogFormVisible: false,
                    title: "",
                    url: "",
                    form: '',
                    checkpolintld: '',
                    id: ''
                },
            }
        },
        computed: {
            tokenchange() {
                return {
                    token: JSON.parse(sessionStorage.getItem('token')).token
                }
            },
            ...mapState('managlist', ['wordList', 'tablist', 'sClass', 'total', 'page', 'find']),
        },
        methods: {
            ...mapActions('managlist', ['FETCH_CHECKPOINT_LIST', 'FETCH_WORD_LIST', 'FETCH_ARTICLE_STAR',
                'FETCH_ARTICLE_LIST', 'FETCH_STARTUPPAGE_LIST', 'FETCH_COMPOSITION_LIST',
                'FETCH_AWESOMECOMPOSITION_LIST'
            ]),
            handleClick(row, status) {
                let as = ''
                switch (status) {
                    case '查看':
                        this.deleteStauts = true
                        this.dialog.title = '词语查看'
                        this.dialog.url = {
                                name: '词语查看',
                                stauts: status
                            },
                            this.dialog.form = row
                        this.dialog.form.star = this.$route.query.star
                        this.dialog.dialogFormVisible = true
                        console.log(this.dialog)
                        break;

                    case '编辑':
                        this.dialog.title = '词语编辑'
                        this.dialog.url = {
                                name: '词语编辑',
                                stauts: status
                            },
                            row.checkpointId = this.$route.query.id
                        row.star = this.$route.query.star
                        as = JSON.parse(JSON.stringify(row))
                        this.dialog.form = as
                        this.dialog.dialogFormVisible = true
                        break;
                    case '删除':
                        row.queryid = this.$route.query.id
                        this.dialog.title = '词语编辑'
                        this.dialog.url = {
                                name: '词语编辑',
                                stauts: status
                            },
                            this.dialog.form = row
                        this.dialog.dialogFormVisible = true
                }
            },
            pageSizeChange(value) {
                console.log(value)
                this.dialog.pageSize = this.find.pageSize
                this.pageInputOver = value
                this.find.pageSize = value
                this.FETCH_WORD_LIST(this.find)
                this.currentPage = this.find.page
            },
            getather(val) {
                //    sessionStorage.setItem('page',val)
                this.dialog.pagea = val
                this.dialog.pageSize = this.find.pageSize
                this.find.id = this.$route.query.id
                this.find.page = val
                this.currentPage = val
                this.FETCH_WORD_LIST(this.find)

            },
        },

        async created() {
            this.find = ''
            this.path = this.$route.path
            console.log('aaaaa上撒啊是大大')
            await this.FETCH_WORD_LIST({
                id: this.$route.query.id
            })
        }

    }
</script>
<style lang="scss" scoped>
    .el-container {
        height: 100%
    }

    .top_tab {
        margin-bottom: 10px;
    }

    .head {
        margin-bottom: 10px;
    }

    .el-main {
        height: 100%;
        overflow: auto;
    }

    .block {
        margin-top: 5px;
        float: right;
        display: flex;
        justify-content: center;
        align-items: center;

        .page_input {
            width: 50px;
            font-size: 14px;

            .el-input__inner {
                height: 30px;
            }

        }
    }
</style>